import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { FiMapPin, FiShare2, FiHeart } from "react-icons/fi";
import Lightbox from 'react-image-lightbox'; // Importing the lightbox library
import 'react-image-lightbox/style.css'; // Import the styles for the lightbox

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./PropertyGallery.css";

export default function PropertyGallery({ images = [], price, title, location, badge }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1); // Track current image index
  const [isOpen, setIsOpen] = useState(false); // Track if lightbox is open

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true); // Open the lightbox when the image is clicked
  };

  const closeLightbox = () => {
    setIsOpen(false); // Close the lightbox
  };

  return (
    <section className="pg">
      <div className="container">
        <div className="pg__wrap">
          <div className="pg__left">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              spaceBetween={12}
              slidesPerView={1}
              className="pg__swiper"
            >
              {images.map((src, idx) => (
                <SwiperSlide key={idx}>
                  <div className="pg__slide">
                    <img
                      className="pg__img"
                      src={src}
                      alt={`Property ${idx + 1}`}
                      onClick={() => openLightbox(idx)} // Open lightbox when clicked
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {badge && <span className="pg__badge">{badge}</span>}

            <div className="pg__actions">
              <button className="pg__iconBtn" type="button" title="Save">
                <FiHeart />
              </button>
              <button className="pg__iconBtn" type="button" title="Share">
                <FiShare2 />
              </button>
            </div>
          </div>

          <div className="pg__right">
            <div className="pg__price">{price}</div>
            <h1 className="pg__title">{title}</h1>
            <div className="pg__loc">
              <FiMapPin />
              <span>{location}</span>
            </div>

            <div className="pg__note">
              Verified listing with complete details. Schedule a visit for a real walkthrough.
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {isOpen && (
        <Lightbox
          mainSrc={images[currentImageIndex]}
          nextSrc={images[(currentImageIndex + 1) % images.length]}
          prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setCurrentImageIndex((currentImageIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setCurrentImageIndex((currentImageIndex + 1) % images.length)
          }
        />
      )}
    </section>
  );
}